var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditMeterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1013",
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1014"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1015"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,14.8V24a4,4,0,0,1-4,4H8a4,4,0,0,1-4-4V8A4,4,0,0,1,8,4h9.2a1,1,0,0,1,0,2H8A2,2,0,0,0,6,8V24a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V14.8a1,1,0,1,1,2,0ZM13,13.46l8.69-8.68a2.7,2.7,0,0,1,3.75,0l1.81,1.81a2.64,2.64,0,0,1,0,3.75l-1.51,1.52h0L18.54,19a4,4,0,0,1-2.83,1.17h-.08l-2.79-.06a1,1,0,0,1-1-1l-.06-2.79A4.06,4.06,0,0,1,13,13.46ZM22.26,7l1.93,1.93a1.14,1.14,0,0,0,1.62,0,.67.67,0,0,0,0-.93L24,6.19a.67.67,0,0,0-.93,0ZM13.8,16.33l0,1.83,1.83,0a2.09,2.09,0,0,0,1.45-.59l5.05-5a2,2,0,0,0,0-2.83L20.85,8.42l-6.46,6.45A2,2,0,0,0,13.8,16.33Z",
    fill: "current",
    className: "color000 svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMeterIcon);
export default __webpack_public_path__ + "static/media/edit-meter-icon.7f782e498de1e6587a956f49b7e77a6f.svg";
export { ForwardRef as ReactComponent };